import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

const isNewLayout = window.$environment.CURRENT_LAYOUT === 'SpireonNew';
const secondary_color = '#C92100';

export const colors = {
  ...parent.colors,
  ...(IS_ADMIN
    ? {
      MENU_BACKGROUND: '#000',
      INPUT_BORDER: '#8A8B8C',
      TERNARY_BORDER: '#8A8B8C',
      MENU_BORDER_COLOR: secondary_color,
      HEADER_COLOR: '#000',
      HEADER_BG: '#000',
      NEW_THEME: true,
      CHIP_BG: '#fff',
      HEADER_COUNT_TEXT: '#fff',
      NON_SELCTED_SVG_COLOR: '#fff',
      MENU_TITLE: '#fff',
      LOGIN_BACKGROUND: '#455560',
      SELECTED_MENU_BG: '#455560',
      PRIMARY_MAIN: '#f0f2f2',
      LINK_COLOR2: secondary_color,
      PRIMARY_CONTRAST: '#455560',
      PRIMARY_BORDER: '#ccc',
      GREY: '#999',
      DAILY_LOG_GRAPH_BORDER: '#919191',
      NORMAL_LINK: '#47545e',
      MODAL_TEXT: '#797979',
      MODAL_HEADING: '#575757',
      MODAL_BACKGROUND: '#fff',
      LIST_TEXT: '#455560',
      HEADER_LIST_TEXT: '#455560',
      LIGHT_BORDER: '#2d2b2b',
      SECONDARY_MAIN: secondary_color,
      SECONDARY_CONTRAST: '#39434c',
      WHITE: '#fff',
      INPUT_BACKGROUND: '#ffffff',
      RED: '#ff0000',
      BLACK: '#000',
      BACKGROUND: '#fff',
      BLACK_THREE: '#373737',
      RED_TWO: '#d34343',
      GREEN: '#32cd32',
      GREEN_TWO: '#97AE46',
      GREY_ELEVEN: '#777070',
      GREY_TWELVE: '#c3c3c3',
      BLACK_FOUR: '#333333',
      GRAPH_BLACK: '#212121',
      CHART_BLUE: '#00e2ff',
      WARNING: '#ffff00',
      GREY_DATA: '#696969',
      LINK_COLOR: secondary_color,
      HEADER_COLOR: '#fff',
      DOCUMENT_LINE: '#2C3249',
      DISABLED_COLOR: '#889ccc',
      RADIO_BACKGROUND: '#f0f2f2',
      FORM_COLOR: '#191e22',
      SUGGESTED_COLOR: '#00b7a0',
      BODY_BACKGROUND: '#f0f2f2',
      CHECKBOX_TICK: secondary_color,
      PAGINATION_BACKGROUND: '#fff',
      PAGINATION_ALTERNATE_BACKGROUND: '#f8f8f8',
      PAGINATION_COLOR: '#fff',
      SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
      MAP: {
        LIGHT_BLACK: '#424D66',
        LIGHTER_BLACK: '#424D66',
        BLACK: '#424D66',
        GREY: '#d1d1d1',
        LIGHT_GREY: '#d1d1d1',
        LIGHTER_GREY: '#d1d1d1',
        WATER: '#2B364F',
        ROAD: '#37425C',
      },
      LOGIN_BUTTON: secondary_color,
      BACKGROUND_MENU: '#455560',
      TITLE_COLOR: '#191e22',
      INPUT_COLOR: '#000',
      INPUT_FOCUS: secondary_color,
      TABLE_ROW_COLOR: '#39434c',
      SORT_ICON: secondary_color,
      LOGOUT_BUTTON: secondary_color,
      PAGINATION_HEADER: '#455560',
      HEADER_TEXT: '#39434c',
      PAGINATION_BORDER: '#f0f2f2',
      RESET_BUTTON: '#47545e',
      ACTION_BORDER: '#455560',
      PRIMARY_BUTTON_TEXT: '#fff',
      FORM_INPUT_BG: '#f0f2f2',
      MULTISELECT_BACKGROUND: '#455560',
      MULTISELECT_LABEL: '#f0f2f2',
      FORM_BACKGROUND: '#fff',
      RESET_BACKGROUND: '#455560',
      RESET_COLOR: '#ffffff',
      CHECKBOX_BORDER: '#d1d3d6',
      SELECT_ACTIONS: '#444',
      SECONDARY_BORDER: '#d0d4d7',
      TAB_HIGHLIGHT: secondary_color,
      TAB_BOTTOM_BORDER: '#9cc663',
      TAB_HIGHLIGHT_BACKGROUND: '#fff',
      ACCORDION_BACKGROUND: '#fff',
      USER_LOGO_BACKGROUND: '#455560',
      USER_LOGO_COLOR: '#ffffff',
      POLICIES_BACKGROUND: '#fff',
      RANGE_PICKER: {
        CELL_BG: '#dfdfdf',
        CELL_HOVER_BG: '#bbbbbb',
      },
      DASHBOARD: {
        CARD: '#fff',
        COLOR: '#000',
      },
      ALERT_COLOR: '#ce1e51',
      ALERT_BACKGROUND: '#2a3135',
    }
    : {}),
  ...(IS_ADMIN
    ? {}
    : {
      PRIMARY_MAIN: '#fff',
      BACKGROUND: isNewLayout ? '#F5F5F5' : '#efefef',
      LIGHT_BORDER: '#bcb1b1',
      HEADER_COUNT_TEXT: isNewLayout ? '#000' : '#373737',
      PRIMARY_CONTRAST: isNewLayout ? '#000' : '#373737',
      SECONDARY_MAIN: isNewLayout ? '#007aff' : 'rgb(45, 57, 66)',
      ...(isNewLayout ? { LIGHT_BORDER: '#bcb1b1' } : {}),
      PUBLIC_HEADERCOLOR: '#061c3f',
      LANGUAGE_SWITCH: '#1589ee',
      HEADER_TEXT: '#f4f6f9',
      BODY_BACKGROUND: '#fff',
      MODAL_BACKGROUND: '#fff',
      MODAL_BORDER: '#d9d9d9',
      MODAL_LINK: '#1589ee',
      LINK_COLOR: isNewLayout ? '#007aff' : '#000',
      HEADER_COLOR: '#1589ee',
      CHECKBOX_TICK: '#000',
      ACTIVE_ROW: isNewLayout ? '#f4f4f4' : 'rgba(247, 247, 247, 0.7)',
      PAGINATION_BACKGROUND: '#fff',
      PAGINATION_COLOR: '#000',
      SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
      BACKGROUND_MENU: '#f4f6f9',
      SECONDARY_MAIN_CONTRAST: '#fff'
    }),
};

const getFont = () => {
  if (IS_ADMIN) return ['NotoSans-Regular', 'sans-serif'].join(',');
  if (isNewLayout) return ['Roboto', 'sans-serif'].join(',');

  return ['"Helvetica Neue", Helvetica, Arial, sans-serif'].join(',');
};
export const fonts = getFont();

export const titleFont = 'Yanone Kaffeesatz';
